/* AdhocQueryEditor.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const _ = require("lodash");

class AdhocQueryEditor extends GameEditor {
    constructor(
        logger,
        di,
        registeredDetails,
        editorState,
        editorLayoutMgr,
        editorLayout,
        userSession,
        editorTabCmpnt,
        solutionsManager,
        steveIo,
        DeviceEntity
    ) {
        super(logger, di, editorState.editorState, editorLayoutMgr);

        this._logger = logger;
        this._registeredDetails = registeredDetails;
        this._editorLayout = editorLayout;
        this._tabCmpnt = editorTabCmpnt;
        this._editorTabState = editorState;
        this._steveIo = steveIo;
        this._userSession = userSession;
        this._deviceEntity = DeviceEntity;
        this._device = undefined;
        this._activeOrgId = userSession.activeOrganization.id;
        let solutionDefinition = solutionsManager.getActiveSolution();
        let AdHocQueryEditorViews = _.get(solutionDefinition, "AdhocQueryEditor.viewNamespaces", []);
        let AdHocQueryEditorActions = _.get(solutionDefinition, "AdhocQueryEditor.actionNamespaces", []);
        let launchOptions = editorState.launchOptions;
        this._selectedDevice = _.get(launchOptions, "selectedDevice", undefined);

        this.setNamespaceGlobs(AdHocQueryEditorViews.concat(AdHocQueryEditorActions), true);

        this._instanceEditorState = {};
        this._tabId = launchOptions.id || "Unknown";

        this.retardActions(true);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    getTabCmpnt() {
        return this._tabCmpnt;
    }

    get activeOrgId() {
        return this._activeOrgId;
    }

    get editorTabStateId() {
        return this._editorTabState.id;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    retrieveDevice(deviceId) {
        if (!deviceId) {
            return Promise.resolve(undefined);
        }
        return this._deviceEntity
            .retrieveDevice(this.activeOrgId, deviceId)
            .then((device) => {
                this._device = device;
                // this._registerFeedListeners();
                return Promise.resolve(this._device);
            })
            .catch((error) => {
                this._logger.warn("Device retriving error", { error });
                return Promise.reject(error);
            });
    }

    setInstanceEditorStateProperty(name, val) {
        _.set(this._instanceEditorState, name, val);
    }

    getInstanceEditorStateProperty(name) {
        return _.get(this._instanceEditorState, name);
    }

    updateTab(name) {
        this._tabCmpnt.setTitle(name);
    }

    closeEditor(id, force) {
        id = id || this._editorTabState.id;
        return super.closeEditor(id, force);
    }

    _switchView(switchTo) {
        this.setActiveView(switchTo);
    }

    _setViewActionText(buttonValue, buttonText) {
        let buttonControl = _.get(
            this._viewContainerElem.nextElementSibling.lastElementChild.querySelectorAll("button-control[value='" + buttonValue + "']"),
            0
        );

        if (buttonControl) {
            buttonControl.innerHTML = buttonText;
        }
    }

    shutdown() {
        let logger = this._logger;

        return super
            .shutdown()
            .then(() => {
                // this._deviceConfigFeed = undefined;
                return Promise.resolve();
            })
            .then(() => {
                this._tabCmpnt = undefined;
                this._registeredDetails = undefined;
                this._editorLayout = undefined;
                this._tabId = undefined;
                this._currentDiscoveryWorkId = undefined;
                this._activeOrgId = undefined;
                this._deviceEntity = undefined;
                this._device = undefined;
            })
            .catch((err) => {
                logger.warn({ error: err }, "DeviceInstanceEditor.shutdown() error");
            });
    }

    _setDirty(dirtyState) {
        this._tabCmpnt.setDirty(dirtyState);
    }
}

module.exports = AdhocQueryEditor;

AdhocQueryEditor.$inject = [
    "$teve.logger",
    "$teve.di",
    "$teve.registeredDetails",
    "editorLayout.editorState",
    "editorLayout.editorLayoutMgr",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "editorLayout.editor.tabComponent",
    "$teve.solutionsManager",
    "$teve.io",
    "$teve.entities.Device"
];

//Optional convenient way to set a tab icon.
AdhocQueryEditor.$editorIcon = "devicemanager.adhoc_query_view";
AdhocQueryEditor.$editorIconType = "base-icon-gl";
